import InputMask from 'react-input-mask'
import React, { useMemo, useState } from 'react'
import { useForm, Controller, useFormContext, useWatch, useFieldArray } from 'react-hook-form'
import Select from 'react-select'
import { colourStyles } from '../../../../Utils/styled-components/react-select.style'
import { getRequest, loadSessionUser } from '../../../../Services/axios.service'
import { useEffect } from 'react'
import { fakegetRequest } from '../../../../Services/fake.service'
import { ECONOMIC_ACTIVITY, TYPE_WASTE } from '../../Utils/residuo-url'
import { PERSONA_CEDULA, VALIDDOCUMENT } from '../../../../Utils/url.api'
import { DOCUMENT } from '../../../../Utils/constants.api'
import { TerritoryProvider } from '../../Context/territoryContext'
import useTerritory from '../../Context/hook/useTerritory'
import { CONTRIBUTORS } from '../../Utils/contributors-url'
import { Box } from '@mui/material'
import MaterialModal from "@mui/material/Modal";
import { boxStyle } from '../../Utils/modal-box'
import { BranchOffice, BranchOfficeList } from '../../Components/BranchOffice'

const baseUrl = process.env.REACT_APP_OGTIC_TERRITORIES

export const Generator = ({ documentTypes, phoneTypes, activities, branchOffices }) => {

    const { control, formState: { errors }, watch, register, setValue, getValues } = useFormContext()
    const { fields, append, remove, update } = useFieldArray({
        control,
        name: 'tipoResiduoAlmacenamientos',
    })

    const [open, setOpen] = useState(false)
    const [inputConfig, setInputConfig] = useState({ documentError: '' })
    const [loadingSet, setLoadingSet] = useState(
        { activity: false, documentNumber: false, Waste: false }
    )
    const [selectedBranchOffice, setSelectedBranchOffice] = useState({ state: null, index: null })

    const watchDocument = useWatch({control, name: 'numeroDocumento'})
    const watchDocumentId = useWatch({control, name: 'documentTypeId'})

    useEffect(() => {
        fetchWaste()
    }, [])

    useEffect(() => {
        if(watchDocumentId !== 3) {
            setValue('nombre', null) 
        }
    }, [watchDocument])

    useEffect(() => {
        setValue('nombre', null) 
        setValue('numeroDocumento', null) 
    }, [watchDocumentId])

    const monthsRange = (range) => {
        const array = Array.from({length: range}, (x, i) => ({value: `${i + 1} Meses`, name: `${i + 1} Meses`}))
        array.unshift({value: "0-15 días", name: "0-15 días"})
        return array
    }    

    const fetchWaste = async () => {
        const headers = {
            Authorization: `Bearer ${loadSessionUser()}`,
        };
        setLoadingSet((cur) => ({ ...cur, waste: true }))
        const response = await getRequest(TYPE_WASTE, {headers})
        setLoadingSet((cur) => ({ ...cur, waste: false }))
        const { success, statusCode, data } = response.data
        if (statusCode == 200 && success) {
            data.map((type) => update(type.identificador === "ESPECIAL" ? 0 : 1,
                { id: 0, generatorId: 0, tipoResiduoId: type.id, tiempoAlmacenamiento: 0 }))
        }
    }

    const validateDocumentNumber = async (value) => {
        const document = value.replace(/-/g, "")
        const documentTypeId = getValues("documentTypeId")
        const identificator = documentTypes.find(d => d.id === documentTypeId)?.identificador
        if (identificator === '1' && document.length >= 11) {
            setLoadingSet(cur => ({ ...cur, documentNumber: true }))
            const response = await getRequest(PERSONA_CEDULA(document))
            setLoadingSet(cur => ({ ...cur, documentNumber: false }))
            const { statusCode, data } = response.data
            if (statusCode == 200 && data) {
                setValue("nombre", data.fullName.toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), { shouldValidate: true });
                return true
            }
            else if (statusCode == 200 && !data) {
                setInputConfig(curr => ({ ...curr, documentError: "Cédula no valida" }))
                return false
            }
            else {
                setInputConfig(curr => ({ ...curr, documentError: 'No se pudo validar la cédula' }))
                return false
            }
        }
        if (identificator === '2') {
            setLoadingSet(cur => ({ ...cur, documentNumber: true }))
            const { data } = await getRequest(CONTRIBUTORS(document), {baseURL: process.env.REACT_APP_OGTIC_CONTRIBUTORS})
            setLoadingSet(cur => ({ ...cur, documentNumber: false }))
            if (data.valid) {
                setValue("nombre", data.data.name, { shouldValidate: true });
                return true
            }
            else {
                setInputConfig(curr => ({ ...curr, documentError: "RNC no valida" }))
                return false
            }
        }
        return true
    }

    const onOtherSelected = () => {
        const selected = getValues("economicActivityGenerators")
        return selected?.some((y) => activities?.find((c) => c?.id === y?.actividadEconomicaId && c?.identificador === "OTROS"))
    }

    const otherSelected = useMemo(() => onOtherSelected(), [watch("economicActivityGenerators")])

    const addBranchOffice = () => {
        setSelectedBranchOffice((cur) => ({ state: null, index: null }))
        setOpen((cur) => true)
    }

    const editBranchOffice = (index) => {
        const spValue = { ...getValues("sucursales")[index] }
        setSelectedBranchOffice((cur) => ({ state: spValue, index: index }))
        setOpen((cur) => true)
    }

    const onAddBranchOffice = (value) => {
        branchOffices.append(value)
    }

    const onEditBranchOffice = (value, index) => {
        branchOffices.update(index, value)
    }

    const deleteBranchOffice = (index) => {
        branchOffices.remove(index)
    }

    const closeModal = () => {
        setSelectedBranchOffice((cur) => ({ state: null, index: null }))
        setOpen((cur) => false)
    }

    const checkBranch = (branch) => {
        return branch.filter(x => x.nombre && x.sucursalResiduos && x.sucursalResiduos?.length > 0)
    }

    return (
        <section className="text-left my-4">
            <div className='custom-form grid grid-cols-1 phone:grid-cols-4 tab-port:grid-cols-[repeat(8,1fr)] gap-x-8'>
                <input type="hidden" {...register('id',
                    { required: { message: 'Este campo es requerido', value: true }, value: 0 }
                )} />
                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label' htmlFor="nombre">
                        Nombre <span className="text-font-muted text-lg">{'(Persona física, jurídica o entidad oficial)'}</span>
                        <span className="text-danger"> *</span>

                    </label>
                    <input className='custom-form__input w-full' id="nombre" type="text"
                        disabled={watch("documentTypeId") !== 3}
                        {...register('nombre',
                            { required: { message: 'Este campo es requerido', value: true } }
                        )} />
                    <span>
                        {errors.nombre?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.nombre?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2">
                    <label className='custom-form__label'>
                        Tipo de Identificación
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="documentTypeId"
                        rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un tipo"
                                getOptionLabel={(option) => option?.description}
                                getOptionValue={(option) => option?.id}
                                options={documentTypes}
                                onChange={(newValue) => onChange(newValue?.id)}
                                value={documentTypes?.find(c => c?.id === value)}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.documentTypeId?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.documentTypeId?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-3">
                    <label className='custom-form__label' htmlFor='numeroDocumento'>
                        Identificación
                        <span className="text-danger"> *</span>
                    </label>
                    <div className="flex gap-x-2 items-center justify-between">
                        <Controller
                            control={control}
                            name="numeroDocumento"
                            rules={{
                                required: { message: 'Este campo es requerido', value: true },
                                validate: {
                                    valid: async (val) => await validateDocumentNumber(val)
                                }
                            }}
                            render={({
                                field: { onChange, name, value, ref, onBlur },
                            }) => (
                                <InputMask
                                    id="numeroDocumento"
                                    className='custom-form__input w-full'
                                    onChange={onChange}
                                    onBlur={onBlur}
                                    inputRef={ref}
                                    mask={watch("documentTypeId") === 1 ? '999-9999999-9' : ''}
                                    maskChar={null}
                                    value={value ?? ""}
                                    disabled={!watch("documentTypeId")}
                                />
                            )}>
                        </Controller>
                        {loadingSet.documentNumber && <div className="spinner-loading"></div>}
                    </div>
                    <span>
                        {errors.numeroDocumento?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.numeroDocumento?.message}</p>}
                        {errors.numeroDocumento?.type === 'valid' &&
                            <p className='text-danger' role="alert">{inputConfig?.documentError}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-3">
                    <label className='custom-form__label' htmlFor="inicioOperaciones">
                        Fecha de Inicio de Operaciones
                        <span className="text-danger"> *</span>
                        </label>
                    <div className="flex gap-x-2 items-center justify-between">
                        <input className='custom-form__input w-full' id="inicioOperaciones" type="date"
                            {...register('inicioOperaciones',
                                {
                                    required: { message: 'Este campo es requerido', value: true },
                                    // valueAsDate: true,
                                })} />
                    </div>
                    <span>
                        {errors.inicioOperaciones?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.inicioOperaciones?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2">
                    <label className='custom-form__label'>
                        Tipo Teléfono
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="phoneTypeId"
                        rules={{
                            required: { value: true, message: 'Este campo es requerido' }
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un tipo"
                                getOptionLabel={(option) => option?.description}
                                getOptionValue={(option) => option?.id}
                                options={phoneTypes}
                                onChange={(newValue) => {
                                    onChange(newValue?.id)
                                }}
                                value={phoneTypes?.find(c => c?.id === value) ?? null}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.phoneTypeId?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.phoneTypeId?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-3">
                    <label className='custom-form__label' htmlFor='telefono'>
                        Teléfono
                        <span className="text-danger"> *</span>
                    </label>
                    <Controller
                        control={control}
                        name="telefono"
                        rules={{
                            required: { message: 'Este campo es requerido', value: true },
                        }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <InputMask
                                id="telefono"
                                className='custom-form__input'
                                onChange={onChange}
                                onBlur={onBlur}
                                inputRef={ref}
                                mask={'(999)-999-9999'}
                                maskChar={null}
                                value={value ?? ""}
                                disabled={!watch("phoneTypeId")}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.telefono?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.telefono?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-3">
                    <label className='custom-form__label' htmlFor='correo'>
                        Correo Electrónico
                        <span className="text-danger"> *</span>
                    </label>
                    <input className='custom-form__input' id="correo" type="email"
                        {...register('correo',
                            {
                                required: { message: 'Este campo es requerido', value: true },
                                pattern: {
                                    value: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                                    message: 'Correo invalido',
                                }
                            })} />
                    <span>
                        {errors.correo?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.correo?.message}</p>}
                        {errors.correo?.type === 'pattern' && <p className='text-danger' role="alert">{errors.correo?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label' htmlFor="direccion">
                        Dirección
                        <span className="text-danger"> *</span>
                    </label>
                    <textarea className="custom-form__input w-full" name="direccion" id="direccion" cols="30" rows="3"
                        {...register('direccion',
                            {
                                required: { message: 'Este campo es requerido', value: true }
                            })} />
                    <span>
                        {errors.direccion?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.direccion?.message}</p>}
                    </span>
                </div>

                <TerritoryProvider>
                    <GeneratorAddress />
                </TerritoryProvider>

                <div className="col-span-full my-6">
                    <hr className='my-8 border-bd-primary'></hr>
                    <h3 className="col-span-full text-2xl text-font-primary">
                        Coordenadas UTM
                        <span className="text-font-muted text-lg">{' (polígono o trazado de la localización, según plano catastral)'}</span>
                    </h3>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label' htmlFor="latitud">
                        Latitud
                        <span className="text-danger"> *</span>
                    </label>
                    <input className='custom-form__input' id="latitud" type="number" step="0.0000000001"
                        {...register('latitud',
                            { required: { message: 'Este campo es requerido', value: true } })} />
                    <span>
                        {errors.latitud?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.latitud?.message}</p>}
                    </span>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label' htmlFor="longitud">
                        Longitud
                        <span className="text-danger"> *</span>

                    </label>
                    <input className='custom-form__input' id="longitud" type="number" step="0.0000000001"
                        {...register('longitud',
                            { required: { message: 'Este campo es requerido', value: true} })} />
                    <span>
                        {errors.longitud?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.longitud?.message}</p>}
                    </span>
                </div>

                <div className="col-span-full my-6">
                    <hr className='my-8 border-bd-primary'></hr>
                    <h3 className="col-span-full text-2xl text-font-primary">
                        Sucursales
                    </h3>
                </div>

                <div className="col-span-full my-4">
                    <button
                        type="button"
                        onClick={() => addBranchOffice()}
                        className="py-4 px-32 text-2xl bg-[#003670] text-white rounded-lg">
                            Agregar nueva sucursal
                        </button>
                </div>

                <MaterialModal
                    open={open}
                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                    sx={{overflow: 'hidden'}}
                >
                    <Box sx={boxStyle}>
                        <div className="sticky top-0 flex justify-between text-2xl text-font-dark font-medium py-6 px-8 border-b border-t border-bd-light bg-white z-30">
                            <h2>Sucursal</h2>
                            <button className="font-danger"
                                onClick={() => closeModal()}>&times;</button>
                        </div>
                        <div className="my-8 px-2">
                            <TerritoryProvider>
                                <BranchOffice 
                                    patchValue={selectedBranchOffice}
                                    onClose={closeModal}
                                    onAdd={onAddBranchOffice}
                                    onEdit={onEditBranchOffice}
                                />
                            </TerritoryProvider>
                        </div>
                    </Box>
                </MaterialModal>
                {watch("sucursales")?.length > 0 &&
                    <BranchOfficeList onDelete={deleteBranchOffice} onEdit={editBranchOffice} rows={watch("sucursales")} /> } 

                <div className="custom-form__control col-span-full tab-port:col-span-4 mt-8">
                    <label className='custom-form__label' htmlFor="numeroLicencia">
                        Número de licencia o Permiso Ambiental

                    </label>
                    <input className='custom-form__input w-full' id="numeroLicencia" type="text"
                        {...register('numeroLicencia')} />
                </div>

                <div className="custom-form__control col-span-full">
                    <label className='custom-form__label'>
                        {"Denominación de las Actividades Económicas que Generan Residuos Sólidos"}
                        <span className="text-danger"> *</span>
                        <p className="text-font-muted text-lg">{' (marque todos los que apliquen)'}</p>
                    </label>
                    <Controller
                        control={control}
                        name="economicActivityGenerators"
                        defaultValue={[]}
                        rules={{ required: { value: true, message: 'Este campo es requerido'} }}
                        render={({
                            field: { onChange, name, value, ref, onBlur },
                        }) => (
                            <Select
                                ref={ref}
                                onBlur={onBlur}
                                styles={colourStyles}
                                isMulti
                                noOptionsMessage={() => "Sin datos"}
                                placeholder="Seleccione un actividad económica"
                                isLoading={loadingSet.activity}
                                getOptionLabel={(option) => option?.nombre}
                                getOptionValue={(option) => option?.id}
                                options={activities}
                                onChange={(newValue) => onChange(newValue.map((x) => ({ actividadEconomicaId: x?.id })))}
                                value={activities?.filter(c => value.find(y => y.actividadEconomicaId === c?.id)) ?? []}
                            />
                        )}>
                    </Controller>
                    <span>
                        {errors.economicActivityGenerators?.type === 'required' &&
                            <p className='text-danger' role="alert">{errors.economicActivityGenerators?.message}</p>}
                    </span>
                </div>

                {otherSelected &&
                    <div className="custom-form__control col-span-full phone:col-span-4">
                        <label className='custom-form__label' htmlFor="descripcion">
                            Otras Actividades Económicas
                            <span className="text-danger"> *</span>
                        </label>
                        <textarea className="custom-form__input" name="descripcion" id="descripcion" cols="30" rows="3"
                            {...register('economicActivityDescripcion', 
                                {required: 
                                    { value: true, message: 'Este campo es requerido'}})} />
                        <span>
                            {errors.economicActivityDescripcion?.type === 'required' &&
                                <p className='text-danger' role="alert">{errors.economicActivityDescripcion?.message}</p>}
                        </span>
                    </div>
                }

                <div className="col-span-full my-6">
                    <hr className='my-8 border-bd-primary'></hr>
                    <h3 className="col-span-full text-2xl text-font-primary">
                        Periodo de almacenamiento
                    </h3>
                </div>

                {/* Faltan las tablas  */}
                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label'>
                        Residuos de Manejo Especial
                    </label>
                    <div className="flex gap-x-2 items-center justify-between">
                        <Controller
                            control={control}
                            name="tipoResiduoAlmacenamientos.0.tiempoAlmacenamiento"
                            render={({
                                field: { onChange, name, value, ref, onBlur },
                            }) => (
                                <Select
                                    ref={ref}
                                    onBlur={onBlur}
                                    styles={colourStyles}
                                    noOptionsMessage={() => "Sin datos"}
                                    placeholder="Seleccione una opción"
                                    getOptionLabel={(option) => option?.name}
                                    getOptionValue={(option) => option?.value}
                                    options={monthsRange(12)}
                                    onChange={(newValue) => onChange(newValue?.value)}
                                    value={monthsRange(12)?.find(c => c?.value === value) ?? null}
                                />
                            )}>
                        </Controller>
                    </div>
                </div>

                <div className="custom-form__control col-span-full phone:col-span-2 tab-port:col-span-4">
                    <label className='custom-form__label'>
                        Residuos Peligrosos
                    </label>
                    <div className="flex gap-x-2 items-center justify-between">
                        <Controller
                            control={control}
                            name="tipoResiduoAlmacenamientos.1.tiempoAlmacenamiento"
                            render={({
                                field: { onChange, name, value, ref, onBlur },
                            }) => (
                                <Select
                                    ref={ref}
                                    onBlur={onBlur}
                                    styles={colourStyles}
                                    noOptionsMessage={() => "Sin datos"}
                                    placeholder="Seleccione una opción"
                                    getOptionLabel={(option) => option?.name}
                                    getOptionValue={(option) => option?.value}
                                    options={monthsRange(6)}
                                    onChange={(newValue) => onChange(newValue?.value)}
                                    value={monthsRange(6)?.find(c => c?.value === value) ?? null}
                                />
                            )}>
                        </Controller>
                    </div>
                </div>
            </div>

        </section >
    )
}

const GeneratorAddress = () => {
    const { control, formState: { errors }, watch, register, setValue, getValues } = useFormContext()

    const { fetchDistricts, fetchMunicipalities, fetchProvinces, loadingSet, territories } = useTerritory()

    const watchProvince = useWatch({control, name: 'provincia'})
    const watchMunicipality = useWatch({control, name: 'municipio'})

    useEffect(() => {
        fetchProvinces()
    }, [])

    useEffect(() => {
        cascadeDropdown()
    }, [watchMunicipality, watchProvince])

    const cascadeDropdown = async () => {
        if(watchProvince) await fetchMunicipalities(watchProvince)
        if(watchMunicipality && watchProvince) await fetchDistricts(watchMunicipality, watchProvince)
    } 

    return (
        <>
            <div className="custom-form__control col-span-full phone:col-span-2">
                <label className='custom-form__label'>
                    Provincia
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="provincia"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione una provincia"
                            isLoading={loadingSet.provinces}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.provinces}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                                // setValue("municipio", null)
                                // setValue("ciudad", null)
                            }}
                            value={territories.provinces?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.provincia?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.provincia?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-full phone:col-span-2">
                <label className='custom-form__label'>
                    Municipio
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="municipio"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione un municipio"
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.municipalities}
                            isLoading={loadingSet.municipalities}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                                // setValue("ciudad", null)
                            }}
                            value={territories.municipalities?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.municipio?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.municipio?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-full phone:col-span-2">
                <label className='custom-form__label'>
                    Ciudad o Sección
                    <span className="text-danger"> *</span>
                </label>
                <Controller
                    control={control}
                    name="ciudad"
                    rules={{ required: { value: true, message: 'Este campo es requerido' } }}
                    render={({
                        field: { onChange, name, value, ref, onBlur },
                    }) => (
                        <Select
                            ref={ref}
                            onBlur={onBlur}
                            styles={colourStyles}
                            noOptionsMessage={() => "Sin datos"}
                            placeholder="Seleccione un ciudad"
                            isLoading={loadingSet.districts}
                            getOptionLabel={(option) => option?.name}
                            getOptionValue={(option) => option?.code}
                            options={territories.districts}
                            onChange={(newValue) => {
                                onChange(newValue?.code)
                            }}
                            value={territories.districts?.find(c => c?.code === value) ?? null}
                        />
                    )}>
                </Controller>
                <span>
                    {errors.ciudad?.type === 'required' &&
                        <p className='text-danger' role="alert">{errors.ciudad?.message}</p>}
                </span>
            </div>

            <div className="custom-form__control col-span-full phone:col-span-2">
                    <label className='custom-form__label' htmlFor="paraje">
                        Paraje
                    </label>
                    <input className='custom-form__input' id="paraje" type="text"
                        {...register('paraje')} />
                </div>

        </>
    )
}